<template>
  <span class="editable" :class="wrapperClasses" @click="makeEditable" @mouseover="keepEditable">
    <template v-if="editable">
      <slot></slot>
    </template>
    <template v-else>
      <span class="text" v-html="plainToBreaks(value)"></span>
    </template>
  </span>
</template>
<script>
import { plainToBreaks } from "../mixins/filters";
import { bus } from "../main";

export default {
  name: "ToggleEdt",
  props: {
    value: {
      type: String,
      default: ""
    },
    mayEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      editable: false
    };
  },
  created() {
    bus.$on("person-details-edited", this.disableEditable);
  },
  computed: {
    wrapperClasses() {
      let cls = this.editable ? ["editable"] : ["text"];
      if (this.mayEdit) {
        cls.push("may-edit");
      }
      return cls;
    }
  },
  methods: {
    makeEditable() {
      if (this.mayEdit) {
        this.editable = true;
        this.$parent.editMode = true;
      }
    },
    keepEditable() {
      if (this.editable) {
        this.editable = true;
        this.$parent.editMode = true;
      }
    },
    disableEditable(ts = 500) {
      setTimeout(() => {
        this.editable = false;
        this.$parent.editMode = false;
      }, ts);
    },
    plainToBreaks(val) {
      return plainToBreaks(val);
    }
  }
};
</script>